import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import PublicNav from "../components/PublicNav";
import { posts } from "../data/posts";

function formatDate(dateString) {
  // Render ISO date as "May 31, 2026" to keep the page consistent
  // with the rest of the site's date formatting.
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function BlogIndex() {
  // Newest first, regardless of the order posts are declared in. Sorting a
  // copy so the source array is left alone.
  const sortedPosts = [...posts].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-brand-dark-bg text-gray-900 dark:text-gray-100">
      <PublicNav />

      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full">
        {/* Header */}
        <section className="mb-12">
          <p className="text-sm font-medium text-brand-violet dark:text-brand-violet-on-dark mb-3 uppercase tracking-widest">
            Blog
          </p>
          <h1 className="text-4xl font-extrabold mb-6 leading-tight">
            Writing on recruitment transparency.
          </h1>
          <p className="text-gray-500 dark:text-gray-400 text-lg leading-relaxed">
            Notes on what we're building and why. Aimed at recruitment
            practitioners, agencies, and anyone thinking seriously about how
            hiring should actually work.
          </p>
        </section>

        <div className="border-t border-gray-100 dark:border-white/10 mb-12" />

        {/* Posts list */}
        <section className="flex flex-col gap-8 mb-16">
          {posts.length === 0 ? (
            <p className="text-gray-500 dark:text-gray-400 italic">
              No posts yet. Check back soon.
            </p>
          ) : (
            sortedPosts.map((post) => (
              <article
                key={post.slug}
                className="group border-b border-gray-100 dark:border-white/10 pb-8 last:border-0"
              >
                <Link
                  to={`/blog/${post.slug}`}
                  className="block hover:opacity-80 transition"
                >
                  <div className="flex items-center gap-3 mb-2 text-xs text-gray-400 uppercase tracking-widest">
                    <time>{formatDate(post.date)}</time>
                    <span>·</span>
                    <span>{post.readingTimeMinutes} min read</span>
                  </div>
                  <h2 className="text-2xl font-bold mb-2 group-hover:text-brand-violet dark:group-hover:text-brand-violet-on-dark transition">
                    {post.title}
                  </h2>
                  <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <p className="mt-3 text-sm font-medium text-brand-violet dark:text-brand-violet-on-dark">
                    Read post →
                  </p>
                </Link>
              </article>
            ))
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}
